import { type ReactNode } from "react";

import { MinusIcon } from "~/components/icons/minus-icon";
import { PlusIcon } from "~/components/icons/plus-icon";
import { Button } from "~/components/ui/button";
import { useTrack } from "~/lib/use-track";

interface Category<T extends string> {
  count: number;
  maxPassengers?: number;
  minPassengers?: number;
  type: T;
}

export function PricingCategory<T extends string>({
  type,
  count,
  label,
  maxPassengers,
  minPassengers,
  onChange,
  disabled = false,
}: {
  label: ReactNode;
  onChange: (count: number) => void;
  disabled: boolean;
} & Category<T>) {
  const track = useTrack();
  return (
    <div className="flex items-center justify-between gap-x-2 gap-y-8">
      <div className="font-medium leading-tight">{label}</div>
      <div className="flex items-center gap-3">
        <Button
          disabled={disabled || count === (minPassengers ?? 0)}
          onClick={() => {
            onChange(count - 1);
            track({ name: "Change Passenger Count", category: type });
          }}
          size="circle"
        >
          <MinusIcon />
        </Button>
        <span className="tabular-nums">{count}</span>
        <Button
          disabled={disabled || count === maxPassengers}
          onClick={() => {
            onChange(count + 1);
            track({ name: "Change Passenger Count", category: type });
          }}
          size="circle"
        >
          <PlusIcon />
        </Button>
      </div>
    </div>
  );
}
